import { formatMinor, toMinor } from '@/lib/money';

/**
 * Presentation-only currency formatting.
 *
 * This used to floor every amount and hide decimals, which is how a Rs 6,089.25
 * sale printed as Rs 6,089 while "Exact" tendered Rs 6,090 and change showed
 * Rs 0. It now delegates to the shared money module (src/lib/money.ts): a whole
 * amount still renders as `Rs 6,089`, but a real fraction is never hidden.
 *
 * Takes RUPEES because every existing caller passes rupees. New code that
 * already holds minor units should call `formatMinor` directly rather than
 * round-tripping through a float.
 */
export function formatRs(amount: number): string {
  return formatMinor(toMinor(amount));
}

/**
 * Compact axis form: 61.3k (02-design-system.md §3).
 *
 * Charts keep their own rounding — a tick label is not a price, and precision
 * there costs legibility for no benefit.
 */
export function formatRsCompact(amount: number): string {
  const floored = Math.floor(amount);
  if (Math.abs(floored) >= 1000) return `${Math.round(floored / 100) / 10}k`;
  return String(floored);
}
